<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :showAdd="showAdd"
            :disabled="disabled"
            :multiple="multiple"
            :autoComplete="autoComplete"
            :dense="dense"
        />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectCurriculumStatus',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        selectedObject: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        modelObject: {
        
        },
        disabled: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        
    },
    watch: {
        
        selected(val){
            
            if(val){
                this.$emit('update:model', val);
                var course = this.items.find(c => c.id == val);
                
                if(course) {
                    this.$emit('update:modelObject', course);
                }
            }
        },

        selectedObject(val){
            this.$emit('update:modelObject', val);
        },
        
        model(val){
            this.selected = val;
        },

        modelObject(val){
            this.selectedObject = val;
            
            if(val && val.id){
                this.selected = val.id;
            }else{
                 this.selected = 0;
            }
        },
    },
    methods: {
        ...mapActions('curriculum', ['ActionFindCurriculumStatus']),        
        
        async getItems() {

            this.loading = true

            await this.ActionFindCurriculumStatus()
                    .then((res) => {
                        this.items = res.data.filter(i => [1,2,3].includes(i.id));
                        this.selected = this.model;
                        this.$emit('onLoad', this.items);
                       
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },
    },
    
}
</script>